namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoHd1Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoHd1';
    }
}
